module.exports = __webpack_public_path__ + "static/media/rnd.e19782e7.png";